import { type InferResponseType, unwrap, withSignal } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the brand kits (ADR-293): one per brand plus Tomorrow's, read whole, so the panel knows every brand
// that has one.

const kits = api.crm["brand-kits"];
export type BrandKit = InferResponseType<typeof kits.$get, 200>["items"][number];

const keys = { all: ["brand-kits"] as const };

export const kitQueries = {
  ...keys,

  list: () =>
    queryOptions({
      queryKey: [...keys.all, "list"],
      queryFn: async ({ signal }) => {
        const items: BrandKit[] = [];
        for (let page = 1, more = true; more; page++) {
          const read = await unwrap(kits.$get({ query: { page: String(page), pageSize: "100" } }, withSignal(signal)));
          items.push(...read.items);
          more = read.hasMore;
        }
        return { items };
      },
    }),
};
